import actions from "../../../../actions";
import { Button } from "../../../ui/button";
import { Card } from "../../../ui/Card";
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogTitle, DialogTrigger } from "../../../ui/dialog";
import { ITrail } from "../../../../../typings";
import { Trash2 } from "lucide-react";
import React, { useEffect, useState } from "react";

interface TrialListProps {
  isNew: boolean
}

const TrialList = ({ isNew }: TrialListProps) => {
  const [trial, setTrial] = React.useState<ITrail[]>([]);
  const [error, setError] = useState<string | null>(null);

  const fetchTrialClass = async () => {
    try {
      const response = await actions.GET_DATA({ url: "campcoupontrail/all" });
      setTrial(response)
    } catch (error) {
    }
  };
  useEffect(() => {
    fetchTrialClass();
  }, [isNew]);

  const deleteTrial = async (id: string) => {
    const response = await actions.DELETE_DATA({
      url:"campcoupontrail/delete",
      params:id
    })
    if (response.success === true) {
      fetchTrialClass();
    }
  };

  return (
    <React.Fragment>
      <main>
        <Card className="p-5 border-none space-y-4 shadow-md shadow-primary">
          <h1 className="text-center xl:text-3xl md:text-2xl text-xl font-bold my-3 xl:my-5 ">
            Trial Class 
          </h1>
          {trial.map((item, index) => {
            return (
              <Card
                key={index}
                className="text-sm sm:text-base p-3 leading-loose gap-5 my-1 flex justify-between"
              >
                <div className="grid gap-2">
                  <h1 className="flex gap-2">
                    <b>Cost :</b>${item.cost}
                  </h1>
                  <h1 className="flex">
                    <b>Time :</b> {item.time} Hour Session{" "}
                  </h1>
                  <h1 className="flex">
                    <b>Age : </b> {item.age} Years{" "}
                  </h1>
                </div>
                <div className="flex items-center justify-end col-span-2">
                  <Dialog>
                    <DialogTrigger>
                      <Button variant="outline" className="border-none">
                        <Trash2 className="hover:text-red_100 size-6 " />
                      </Button>
                    </DialogTrigger>
                    <DialogContent className="bg-white_100 w-5/6 sm:w-full">
                      <DialogTitle>Confirm Delete</DialogTitle>
                      <DialogDescription className="md:text-lg">
                        Are you sure you want to delete this Trial?
                      </DialogDescription>
                      <div className="flex justify-end space-x-2 mt-6">
                        <DialogClose asChild>
                          <Button className="text-white_100">Cancel</Button>
                        </DialogClose>
                        <DialogClose asChild>
                          <Button
                            className="bg-red_100 text-white_100"
                            onClick={() => {
                              deleteTrial(item._id);
                            }}
                          >
                            Delete
                          </Button>
                        </DialogClose>
                      </div>
                    </DialogContent>
                  </Dialog>
                </div>
              </Card>
            );
          })}
        </Card>
      </main>
    </React.Fragment>
  );
};

export default TrialList;
